import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import SpinnerDot from "../../components/SpinnerDot";
import auth from "../../firebase/auth";
import useAxiosJwtQuery from "../../hooks/useAxiosJwtQuery";
import axiosJwt from "../../utils/axiosJwt";

export default function ManageUsers() {
  const navigate = useNavigate();

  const [users, refetch] = useAxiosJwtQuery(`/users`);

  const handleMakeAdmin = (email) => {
    const newDetails = {
      email,
      admin: true,
    };

    axiosJwt
      .put(`${process.env.REACT_APP_SERVER_ENDPOINT}/users`, newDetails)
      .then(({ data }) => {
        if (data.modifiedCount || data.upsertedCount || data.matchedCount) {
          toast.success("Made User Admin Successfully");

          refetch();
        } else {
          toast.error("Couldn't Make User Admin");
        }
      })
      .catch((error) => {
        if ([401, 403].includes(error?.response?.status)) {
          signOut(auth);

          localStorage.removeItem("token");

          navigate("/login");
        }

        toast.error("Couldn't Make User Admin");
      });
  };

  return (
    <div class="w-auto">
      <div class="hero-content flex flex-col">
        <ToastContainer />

        <h1 class="text-center text-5xl font-bold">Manage Users</h1>

        <div class="card flex-shrink-0 w-full">
          {!users ? (
            <SpinnerDot />
          ) : (
            <div class="overflow-x-auto">
              <table class="table w-fit mx-auto text-center">
                <thead>
                  <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Email</th>
                    <th className="text-center">Role</th>
                    <th></th>
                  </tr>
                </thead>

                <tbody>
                  {users.map(({ _id, name, email, admin }, i) => (
                    <tr key={_id}>
                      <th>{i + 1}</th>
                      <td>{name}</td>
                      <td>{email}</td>
                      <td className="font-bold">
                        {admin ? (
                          <span className="text-secondary">ADMIN</span>
                        ) : (
                          <span className="text-accent">BUYER</span>
                        )}
                      </td>
                      <td>
                        <button
                          onClick={() => {
                            handleMakeAdmin(email);
                          }}
                          className="btn border-0 btn-primary"
                          disabled={admin}
                        >
                          MAKE ADMIN
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
